import { render, staticRenderFns } from "./PdEditor.vue?vue&type=template&id=2cca5bb6&"
import script from "./PdEditor.vue?vue&type=script&lang=js&"
export * from "./PdEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports